export default {
  LIVE: 'LIVE',
  HOLD: 'HOLD',
  DISCONNECTED: 'DISCONNECTED',
} as const;
